export default "__VITE_ASSET__Bn13FXEF__"